module.exports = __webpack_public_path__ + "static/media/icon-medal.2ebc8ba1.svg";